// src/app/auth/authRoles.js
//
// The backend currently exposes a simplified role model (e.g. "user" and "admin")
// via accessManagement/getState.
//
// Requirement:
// - as "user": only the OPERATOR navigation group should be visible
// - as "admin": everything should be visible
//
// We still keep the old keys (device, measurement, project, ...) because they are
// referenced from navigation + route configs, but we map them to the new roles.

const ADMIN_ROLES = ['admin', 'Admin', 'superadmin', 'superAdmin', 'SuperAdmin'];
const OPERATOR_ROLES = ['user', 'operator'];

const uniq = (arr) => Array.from(new Set((arr || []).filter(Boolean)));
const withAdmin = (roles) => uniq([...(roles || []), ...ADMIN_ROLES]);

export const authRoles = {
  onlyGuest: [],

  // generic buckets
  user: withAdmin(OPERATOR_ROLES),
  operator: withAdmin(OPERATOR_ROLES),
  admin: uniq(ADMIN_ROLES),

  // OPERATOR area (user + admin)
  event: withAdmin(OPERATOR_ROLES),
  device: withAdmin(OPERATOR_ROLES),
  bridge: withAdmin(OPERATOR_ROLES),
  infrastructureElement: withAdmin(OPERATOR_ROLES),
  elementType: withAdmin(OPERATOR_ROLES),
  measurement: withAdmin(OPERATOR_ROLES),
  eda: withAdmin(OPERATOR_ROLES),

  // ADMINISTRATIVE area (admin only)
  project: uniq(ADMIN_ROLES),
  deviceType: uniq(ADMIN_ROLES),
  sensorType: uniq(ADMIN_ROLES),
  userAccount: uniq(ADMIN_ROLES),
  userRole: uniq(ADMIN_ROLES),

  // Profile should be accessible for all logged-in roles
  userProfile: withAdmin(OPERATOR_ROLES)
};

export default authRoles;
